<div class="app-header header-shadow">
  <div class="app-header__logo">
    <ng-container *ngIf="(apiService.currentUser | async)?.clientLogo as logo; else staticLogo">
      <img [src]="logo" class="client-logo" alt="Logo" />
    </ng-container>
    <ng-template #staticLogo>
      <div class="logo-src"></div>
    </ng-template>
    <div class="header__pane ml-auto">
      <div>
        <button
          type="button"
          (click)="onToggleSidebar()"
          class="hamburger close-sidebar-btn hamburger--elastic"
          data-class="closed-sidebar"
        >
          <i class="pe-7s-menu icon-gradient bg-mean-fruit"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="app-header__mobile-menu">
    <div>
      <button
        type="button"
        (click)="onToggleSidebar()"
        class="hamburger hamburger--elastic mobile-toggle-nav"
      >
        <i class="fa fa-solid fa-bars"></i>
      </button>
    </div>
  </div>
  <div class="app-header__menu">
    <span>
      <button
        type="button"
        class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav"
        (click)="toggleClsss()"
      >
        <span class="btn-icon-wrapper">
          <i class="fa fa-ellipsis-v fa-w-6"></i>
        </span>
      </button>
    </span>
  </div>
  <div class="app-header__content" [ngClass]="isClassAdded ? 'header-mobile-open' : ''">
    <div class="app-header-right">
      <div class="header-btn-lg pr-0" *ngIf="apiService.currentUser | async as user">
        <div class="widget-content p-0">
          <div class="widget-content-wrapper">
            <!-- Notification Bell -->
            <div class="widget-content-left mr-3">
              <div class="dropdown">
                <button
                  type="button"
                  class="btn-shadow p-1 btn btn-primary btn-sm position-relative"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                  title="Notifications"
                >
                  <i class="fa text-white fa-bell pr-1 pl-1"></i>
                  <span *ngIf="unreadCount > 0" class="notification-badge">
                    {{ unreadCount > 9 ? '9+' : unreadCount }}
                  </span>
                </button>
                <div class="dropdown-menu dropdown-menu-end notification-dropdown shadow-lg">
                  <div class="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
                    <span class="fw-semibold">Notifications</span>
                    <span *ngIf="unreadCount > 0" class="badge bg-primary rounded-pill">{{ unreadCount }} new</span>
                  </div>
                  <div *ngIf="notifications.length === 0" class="px-3 py-4 text-center text-muted small">
                    <i class="fa fa-bell-slash d-block mb-2" style="font-size: 1.5rem; opacity: 0.4;"></i>
                    No notifications
                  </div>
                  <div
                    *ngFor="let n of notifications"
                    class="notification-item d-flex gap-2 px-3 py-2"
                    [class.unread]="!n.read"
                    (click)="markRead(n)"
                  >
                    <div class="notification-icon-wrap flex-shrink-0">
                      <i class="fa" [ngClass]="n.icon || 'fa-info-circle'"></i>
                    </div>
                    <div class="flex-grow-1 overflow-hidden">
                      <div class="notification-title fw-semibold">{{ n.title }}</div>
                      <div class="notification-message text-muted small text-truncate">{{ n.message }}</div>
                      <div class="notification-time text-muted" style="font-size: 0.7rem;">{{ n.time }}</div>
                    </div>
                  </div>
                  <div *ngIf="unreadCount > 0" class="border-top">
                    <button type="button" class="btn btn-link btn-sm w-100 py-2 text-primary" (click)="markAllRead()">
                      Mark all as read
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- User / Logout -->
            <div class="dropdown">
              <div class="d-flex align-items-center header-user-toggle"
                   data-bs-toggle="dropdown" aria-expanded="false" role="button" style="cursor:pointer;">
                <div class="widget-content-left">
                  <div class="header-user-avatar">{{ getInitials(user.userName) }}</div>
                </div>
                <div class="widget-content-left ml-3 header-user-info">
                  <div class="widget-heading">{{ user.userName }}</div>
                  <div class="widget-subheading">{{ user.role }}</div>
                </div>
              </div>
              <ul class="dropdown-menu dropdown-menu-end shadow-sm mt-1">
                <li>
                  <button type="button" class="dropdown-item text-danger" (click)="logout()">
                    <i class="fa fa-sign-out-alt me-2"></i>Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
